<template>
	<modal ref="modal">
		<template #title>{{ title() }}</template>
		<template #banner>
			<div class="bg-primary">
				<div class="bg-black-25">
					<div class="content text-center">
						<div class="py-0 mb-3 text-uppercase">
							<h1 class="fw-bold text-white mb-2">
								{{ unimember.rank }}
							</h1>
							<h2 class="h4 fw-normal text-white-75 fs-sm">
								Current Subscription
							</h2>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template #body>
			<div class="table-responsive">
				<table class="table table-striped table-borderless table-vcenter">
					<tbody>
						<tr>
							<th>Full Name</th>
							<td class="text-center">{{ $page.props.user.full_name }}</td>
						</tr>
						<tr>
							<th>Expiry</th>
							<td class="text-center">{{ unimember.expiry }}</td>
						</tr>
						<template v-if="form.action === 'upgrade' && form.rebates.int > 0">
							<tr>
								<th>Months Left</th>
								<td class="text-center">{{ subscriptions.months_left }}</td>
							</tr>
							<tr>
								<th>Credits Earn</th>
								<td class="text-center">&#8369;{{ form.rebates.string }}</td>
							</tr>
						</template>
					</tbody>
				</table>
			</div>
			<template v-if="form.action === 'upgrade' && form.rebates.int > 0">
				<div class="alert alert-success">
					<p class="mb-0">Price is less credits already</p>
				</div>
			</template>
			<div class="form-group">
				<span class="text-danger fw-bold mx-1">*</span><label class="form-label">Membership</label>
			</div>
			<div
				v-for="(collections, index) in subscriptions.products"
				:key="index"
				class="block block-rounded"
			>
				<div class="block-header block-header-default">
					<h3 class="block-title">
						{{ index }}
					</h3>
				</div>
				<div class="block-content">
					<div class="row">
						<div
							class="col-6"
							v-for="subscription in collections"
							:key="subscription.prod_id"
						>
							<div class="form-check form-block mb-3">
								<input
									:checked="form.platf_term==subscription.prod_id"
									v-model="form.subscription"
									class="form-check-input"
									type="radio"
									:value="subscription.prod_id"
									:id="subscription.prod_id"
									name="subscription"
								/>
								<label class="form-check-label" :for="subscription.prod_id">
									<span class="d-flex align-items-center">
										<h6 class="fs-sm mb-0">
											{{ subscription.membership }}
										</h6>
									</span>
									<small v-if="form.action!='pf_upgrade' && !unimember.is_pf">
										<span v-if="form.action === 'upgrade' && form.rebates.int > 0">
											<s class="text-muted">&#8369;{{ subscription.amount }}</s>
											<span class="fs-sm text-danger">&#8369;{{ subscription.less }}</span>
										</span>
										<span v-else> &#8369;{{ subscription.amount }} </span>
										<span v-if="subscription.add_display" class="badge bg-warning ms-1">
											{{ subscription.add_display }}
										</span>
									</small>
								</label>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="form.action=='pf_upgrade' || unimember.is_pf" class="form-group">
				<div class="mb-4">
					<span class="text-danger fw-bold mx-1">*</span><label class="form-label" for="platf_amount">Any Amount (Minimum of &#8369;497.00)</label>
					<input
						v-model="form.platf_amount"
						:class="{ 'is-invalid': form.errors.platf_amount }"
						type="number"
						class="form-control"
						id="platf_amount"
						placeholder="Enter your amount"
						min="497"
					/>
					<div v-if="form.errors.platf_amount" class="invalid-feedback">
						<i class="fa fa-exclamation-circle"></i>
						{{ form.errors.platf_amount }}
					</div>
				</div>
			</div>

			<div v-if="form.payment_method == 'CARD'">
				<div v-if="unimember.has_card">
					<div class="form-check form-switch mb-4">
						<input
							v-model="form.use_existing_card"
							class="form-check-input"
							type="checkbox"
							:value="true"
							id="example-switch-default1"
							name="example-switch-default1"
						/>
						<label class="form-check-label form-label" for="example-switch-default1">
							Use existing card
						</label>
					</div>
					<div v-if="form.use_existing_card" class="mb-4">
						<p class="mb-0">
							<span class="fw-semibold">CARD: </span>
							<i>**** **** **** {{ unimember.card.last4 }}</i>
							<span class="badge bg-primary ms-2">{{ unimember.card.brand }}</span>
						</p>
					</div>
				</div>
				<div v-if="!form.use_existing_card" class="form-group mb-4">
					<span class="text-danger fw-bold mx-1">*</span><label class="form-label">Card Information</label>
					<stripe @accept-token="acceptToken" ref="stripe" />
					<div v-if="form.errors.card" class="invalid-feedback d-block">
						<i class="fa fa-exclamation-circle"></i>
						{{ form.errors.card }}
					</div>
				</div>
			</div>
		</template>
		<template #footer>
			<span class="float-start">
				<button v-if="unimember.is_pf"
					@click="payLater"
					type="submit"
					class="btn btn-alt-info"
					:disabled="form.platf_amount<497"
				>
					<span v-if="form.processing">
						<div class="spinner-border spinner-border-sm text-dark" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
						<span class="mx-2">Please wait...</span>
					</span>
					<span v-else>
						<span>Pay Later</span>
					</span>
				</button>
			</span>
			<button
				@click="upgradeRenew"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="
					(form.payment_method === 'CARD' && !form.use_existing_card && !form.token) ||
					form.processing || !form.subscription ||
					((form.action=='pf_upgrade' || unimember.is_pf) && form.platf_amount<497)
				"
			>
				<span v-if="form.processing">
					<div class="spinner-border spinner-border-sm text-dark" role="status" >
						<span class="sr-only mr-1">Please wait...</span>
					</div>
					<span class="mx-2">Please wait...</span>
				</span>
				<span v-else>
					<span v-if="form.action=='pf_upgrade' || unimember.is_pf">Give Now</span>
					<span v-else>Pay Now</span>
				</span>
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import Stripe from '../Stripe';
import { ref, watch, computed } from 'vue';
import { useForm, usePage } from '@inertiajs/inertia-vue3';

export default {
	props: {
		test 			: String,
		action 			: String,
		unimember 		: Object,
		subscriptions 	: Object,
		api_response 	: Object,
		payment_method 	: String
	},
	components: { Stripe },
	// mounted(){
	// 	this.page = this.$page;
	// },
	setup(props) {
		const app_url 	= Ziggy.url;
		const modal 	= ref(null);
		const form 		= useForm({
							action 				: props.action,
							payment_method 		: props.payment_method,
							subscription 		: props.unimember.is_pf ? props.unimember.platf_term : null,
							platf_term 			: props.unimember.platf_term,
							platf_amount 		: props.unimember.platf_amount,
							token 				: null,
							rebates 			: props.subscriptions.rebates,
							use_existing_card 	: false,
							test 				: props.test,
						});

		const title = () => {
						return {
							renew: 'MEMBERSHIP RENEWAL'+(props.unimember.is_pf ? ' CHARGING' : ''),
							upgrade: 'MEMBERSHIP UPGRADE',
							pf_upgrade: 'AVAIL YOUR PLATINUM FAITHFUL',
						}[props.action]
					};

		const payLater = () => {
						form.post(route('member.post.renew-paylater'), {
							preserveState: true,
							preserveScroll: true,
							only: ['flash','api_response','unimember','subscriptions'],
							onSuccess: () => toggleModal
						})
					};

		const upgradeRenew = () => {
						form.post(route('member.post.upgrade-renew'), {
							preserveState: true,
							preserveScroll: true,
							only: ['flash','unimember','subscriptions'],
							onSuccess: () => toggleModal,
						})
					};

		const toggleModal = () => {
							modal.value.toggleModal()
						};

		const acceptToken = (token) => {
							form.token = token
						};

		watch(
			() => props.payment_method,
			(payment_method) => {
				form.payment_method = payment_method
			}
		)

		return {
			app_url,
			modal,
			form,
			title,
			payLater,
			upgradeRenew,
			toggleModal,
			acceptToken,
		}
	},
}
</script>
